export default {
  toastTitle: null,
  toastMessage: null,
  toastType: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/toast/state.js